import { Directive, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Directive({
    selector: '[full-content-height]'
})
export class FullContentHeight implements AfterViewInit, OnDestroy {
    elementRef;
    resizeObservable$: Observable<Event>
    resizeSubscription$: Subscription
    constructor(el: ElementRef) {
        this.elementRef = el;
    }

    ngAfterViewInit() {
        this.setHeight();
        this.resizeObservable$ = fromEvent(window, 'resize')
        this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
            setTimeout(() => {
                this.setHeight();
            },100);
        })
    }

    ngOnDestroy() {
        this.resizeSubscription$.unsubscribe()
    }

    async setHeight() {
        return;
        const elem: any = document.getElementById("ion-page-content");
        // the ion content has its own associated scrollElement
        const scrollElement = await (elem as any).getScrollElement();
        const appPane: any = document.getElementById("app-pane");
        //const totalContentHeight = scrollElement.scrollHeight;
        const totalContentHeight = appPane.getBoundingClientRect().height;
        const viewportHeight = elem.offsetHeight;
        const contentDiv = this.elementRef.nativeElement;
        // document.getElementById('contentScrollableDiv');
        const boundingRect = contentDiv.getBoundingClientRect();
        const requiredHeight = (totalContentHeight - (boundingRect.top + 10)) + 'px';
        contentDiv.style.height = requiredHeight;
    }

}
